
/**
 * Mena sekcie
 */
export enum SectionNames {
  mobileSidePick = 'mobileSidePick',
  introductionNewInstructor = 'introductionNewInstructor',
  startSection = 'startSection',
  startSectionSecond = 'startSectionSecond',
  startSectionThird = 'startSectionThird',
  startSectionFourth = 'startSectionFourth',
  startSectionFifth = 'startSectionFifth',
  startSectionSixth = 'startSectionSixth',
  startSectionSeventh = 'startSectionSeventh',
  startSectionEight = 'startSectionEight',
}

type NameKeys = keyof typeof SectionNames;
type NameKeyFields = { [key in NameKeys]: string }

export interface UiState extends NameKeyFields {
  NameKeyFields: () => void
}

export enum TutorialEventType {
  drawStart = 'drawStart',
  drawNoInput = 'drawNoInput',
  drawNoAngle = 'drawNoAngle',
  drawFoul = 'drawFoul',
  drawSuccess = 'drawSuccess',
  angleSuccess = 'angleSuccess',
  firstFinish = 'firstFinish',
  goodFinish = 'goodFinish',
  okFinish = 'okFinish',
  badFinish = 'badFinish',
  awaitingEvent = 'awaitingEvent'
}

export enum TutorialObjectiveIds {
  runUp = 'tutorialTask1',
  angle = 'tutorialTask2',
  windUp = 'tutorialTask3',
  validAttempt = 'tutorialTask4',
}
